import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { TableRowsLoader } from '../../components/styledComponent/table/TableLoader';
import { endpoints } from '../../api/endpoints';
import { TableHeadCell } from '../../components/styledComponent/table/TableCell';
import { Grid, Paper, Typography } from '@mui/material';
import { TablePagination } from '../../components/pagination/Pagination';
import { LoadingButton } from '@mui/lab';
import { ControlledInput } from '../../components/forms/input/ControlledInput';
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { Search } from '@mui/icons-material';
import CustomSelect from '../../components/forms/select/CustomSelect';
import { useCrudForm } from '../../api/useCrudForm';
import SingleInputDateRangePicker from '../../components/dateRange/DateRange';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import * as XLSX from 'xlsx';

export default function LockerAcessHistoryListTable({ refetchData, loading, setLoading, buttonLoading, setButtonLoading, count, setSkip, setTake, take, skip, rows }: { refetchData: any, loading: any, setLoading: any, buttonLoading: any, setButtonLoading: any, take: any, skip: any, setSkip: any, setTake: any, count: any, rows: any }) {
    const [lockerLocationList, setLockerLocationList] = useState<any | null>()
    const [exportLoading, setExportLoading] = useState<boolean>(false)

    const initialValues = { name: '', lockerNumber: '', fromDate: '', toDate: '', location: '' }
    const { get } = useCrudForm();

    const { handleSubmit, control, formState: { errors, }, setValue, getValues } = useForm({
        defaultValues: initialValues
    })

    const getFilterSelectData = async () => {
        get({
            endpoints: endpoints.common.getLocations(),
            onSuccess: (data: any) => {
                setLockerLocationList(data.data)
            },
            onError: (error: any) => {
                console.log(error)
            }
        })
    }

    const handleSearchButtonClick = (values: any) => {
        setSkip(0)
        setTake(take)
        setButtonLoading(true)
        refetchData({ lockerNumber: values?.lockerNumber, fromDate: values?.fromDate, toDate: values?.toDate, location: values?.location, name: values?.name })
    };

    const resetSearch = () => {
        setValue("name", '');
        setValue("fromDate", '');
        setValue("toDate", '');
        setValue("location", '');
        setValue("lockerNumber", '');
        refetchData({})
    };

    const handleDownload = () => {
        setExportLoading(true)
        get({
            endpoints: endpoints.lockerAccessHistory.list({
                fromDate: getValues()?.fromDate,
                toDate: getValues()?.toDate,
                isExport: true,
                location: getValues()?.location,
            }),
            onSuccess: (data: any) => {
                const excelData = data.data?.list && data.data?.list.length > 0 ? data.data?.list.map((cus: any, index: number) => [
                    index + 1,
                    cus.date,
                    `${cus?.firstName ?? ''} ${cus?.middleName ?? ''} ${cus?.lastName ?? ''}`,
                    cus.lockerNumber,
                    cus.checkInTime,
                    cus.checkOutTime
                ]) : []
                const headers = ["S.N", "Date", "Customer Name", "Locker", "Check In", "Check Out"]
                const workbook = XLSX.utils.book_new();
                const worksheet = XLSX.utils.json_to_sheet(excelData);
                XLSX.utils.book_append_sheet(workbook, worksheet, "Locker Access History");
                XLSX.utils.sheet_add_aoa(worksheet, [headers]);
                const name = `LockerAccessHistory.xlsx`;
                XLSX.writeFile(workbook, name, { compression: true });
                setExportLoading(false)
            },
            onError: () => setExportLoading(false)
        })
    };

    useEffect(() => {
        setLoading(true)
        refetchData({ lockerNumber: getValues()?.lockerNumber, fromDate: getValues()?.fromDate, toDate: getValues()?.toDate, location: getValues()?.location, name: getValues()?.name })
        getFilterSelectData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [skip, take])

    return (<>
        <Typography sx={{ color: 'gray', fontSize: '13px', marginBottom: '12px' }}>Search Locker Access</Typography>
        <form>
            <Grid container spacing={2} style={{ display: 'flex', justifyContent: 'start', marginBottom: "24px" }}>
                <Grid item xs={3} >
                    <ControlledInput name="name" control={control} errors={errors} label="Customer" size={'small'} />
                </Grid>
                <Grid item xs={2}>
                    <ControlledInput name="lockerNumber" control={control} errors={errors} label="Locker number" size={'small'} />
                </Grid>
                <Grid item xs={3}>
                    <CustomSelect height='2.5rem' label="Locker Location" name="location" errors={errors?.location?.message} control={control} values={lockerLocationList ?? []} size={12} setValue={setValue} />
                </Grid>
                <SingleInputDateRangePicker control={control} errors={errors} setValue={setValue} getValues={getValues} />
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'right' }}>
                    <LoadingButton loading={buttonLoading} onClick={() => resetSearch()} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#3150A1', '&:hover': { backgroundColor: '#3150A1' } }} >Reset</LoadingButton>
                    <LoadingButton type='submit' loading={buttonLoading} onClick={(e) => { e.preventDefault(); handleSubmit(handleSearchButtonClick)() }} variant="contained" sx={{ marginLeft: '16px', backgroundColor: '#3150A1', '&:hover': { backgroundColor: '#3150A1' } }} ><Search /></LoadingButton>
                    <LoadingButton loading={exportLoading} onClick={() => handleDownload()} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#3150A1', marginLeft: '16px', '&:hover': { backgroundColor: '#3150A1', } }}>
                        <CloudDownloadIcon />
                        <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Export</Typography>
                    </LoadingButton>
                </Grid>
            </Grid>
        </form >
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 460 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>

                            <TableHeadCell>S.N</TableHeadCell>
                            <TableHeadCell align="left">Date</TableHeadCell>
                            <TableHeadCell align="left">Customer Name</TableHeadCell>
                            <TableHeadCell align="left">Locker Number</TableHeadCell>
                            <TableHeadCell align="left">Check In</TableHeadCell>
                            <TableHeadCell align="left">Check Out</TableHeadCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ? <TableRowsLoader rowsNum={6} colNum={6} />
                            : (!rows || rows.length <= 0 ?
                                <TableRow>
                                    <TableCell colSpan={6} align='center'>No Data Found</TableCell>
                                </TableRow>
                                : rows.map((row: any, index: number) => (
                                    <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}  >
                                        <TableCell style={{ fontSize: "12px" }}>{skip > 0 ? skip * take + index + 1 : ++index}</TableCell>
                                        <TableCell align="left" style={{ fontSize: "12px" }}>{row.date}</TableCell>
                                        <TableCell align="left" style={{ fontSize: "12px" }}>{`${row?.firstName ?? ''} ${row?.middleName ?? ''} ${row?.lastName ?? ''}`}</TableCell>
                                        <TableCell align="left" style={{ fontSize: "12px" }}>{row.lockerNumber}</TableCell>
                                        <TableCell align="left" style={{ fontSize: "12px" }}>{row.checkInTime}</TableCell>
                                        <TableCell align="left" style={{ fontSize: "12px" }}>{row.checkOutTime}</TableCell>
                                    </TableRow>
                                )))}
                    </TableBody>
                </Table>
            </TableContainer>
            {rows && (rows?.length > 0 || !loading) ? <TablePagination count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} /> : null}
        </Paper>
    </>
    );
}
